import customMapStyles 		from 'javascripts/modules/map-styles.js';
import $ from 'jquery';

class MyGoogleMap {

	constructor(moduleName, params = {}){

		this.trigger       = document.querySelector(`[data-trigger   = '${moduleName}']`);
		this.target        = document.querySelector(`[data-target    = '${moduleName}']`);
		this.markersDatas  = document.querySelectorAll(`[data-marker = '${moduleName}']`);
		this.map           = null;
		this.mapInfowindow = null;
		this.mapMarkers    = [];
		
		this._init(params);
	}


	_init(params){
		if(this.trigger){
	  	document.addEventListener('DOMContentLoaded', (event) => {
				this._renderMap(params);
	  	});
		}
	}


	_renderMap({
			streetViewControl = false,
			panControl        = false,
			scrollwheel       = false,
			cluster           = false
		} = {}) {

		const args = {streetViewControl, panControl, scrollwheel};

		args.styles = customMapStyles;
		
		// Prevent scroll to interfere with scroll on small screen
		if (Foundation.MediaQuery.current === 'small') {
			args.draggable = false;
		}
		
		this.map = new google.maps.Map(this.target, args);

		this._initMarkers();
		this._initInfoWindow();
		this._centerMap();

		if(cluster){
			this._initClusters();
		}
	}


	_initClusters(){
		const clusterArgs = {
			styles: [{
				url:       'assets/images/map/cluster.svg',
				height:    80,
				width:     58,
				anchor:    [-18, 0],
				textColor: '#ffffff',
				textSize:  20	
			}]
		};
		const markerCluster = new MarkerClusterer(this.map, this.mapMarkers, clusterArgs );
	}


	_initMarkers(){
		for(let marker of this.markersDatas){
			this._addMarker(marker);
		}
	}
	

	_addMarker(marker) {

		const markerLat    = marker.getAttribute('data-lat');
		const markerLng    = marker.getAttribute('data-lng');
		const markerLatLng = new google.maps.LatLng( markerLat, markerLng );
		const markerIcon   = {
				url:        marker.getAttribute('data-icon'),
				scaledSize: new google.maps.Size(30, 42),
		};

		const markerParams = {
			position:    markerLatLng,
			map:         this.map,
    	optimized:   false,
			icon:        markerIcon,
			animation:   google.maps.Animation.DROP,
			typeOfOffer: marker.getAttribute('data-filter')
		};
		
		const newMarker = new google.maps.Marker(markerParams);

		// Store the marker into a global array
		this.mapMarkers.push(newMarker);

		// if marker contains HTML, add it to an infoWindow
		if( marker.children.length > 0 ) {

			// show info window when marker is clicked
			google.maps.event.addListener (
				newMarker, 'click', this._triggerInfowindow.bind(this, marker, newMarker)
			);
		}

	}


	_initInfoWindow(){
		this.mapInfowindow = new google.maps.InfoWindow();
		google.maps.event.addListener(
			this.mapInfowindow, 'closeclick', ()=> this._centerMap() 
		);
	}


	_triggerInfowindow(marker, newMarker){

		this.map.setZoom(14);
		this.map.panTo(newMarker.position);

		// Make the marker bounce 3 times then stop
		newMarker.setAnimation(google.maps.Animation.BOUNCE);
		setTimeout( 
			()=> newMarker.setAnimation(null), 700*3
		);

		this.mapInfowindow.setContent( marker.innerHTML );
		this.mapInfowindow.open( this.map, newMarker );

	}


	_centerMap() {

		const bounds = new google.maps.LatLngBounds();

		if(this.mapMarkers.length > 1) {

			// loop through all markers and extend bounds
			for(let marker of this.mapMarkers){
				const markerCoord = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
				bounds.extend( markerCoord );
			}
			this.map.fitBounds( bounds );

		} else {
			const markerLat = this.mapMarkers[0].position.lat();
			const markerLng = this.mapMarkers[0].position.lng();
			const markerCoord = new google.maps.LatLng( markerLat, markerLng);
			this.map.setCenter(markerCoord);
			this.map.setZoom(12);
		}

	}

}

export default MyGoogleMap;